module.exports = __webpack_public_path__ + "img/icon_map_11_off_111.9da33ee7.png";